import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Button, CardContent, CardHeader, Divider, Grid } from '@material-ui/core';
import { ServiceValues } from '../../../../../values/ServiceValues';
import { ServiceAxios } from '../../../../../services/ServiceEW';
import { useStyles } from './ModalidadeTrapAmericanoStyles';
import Typography from '@material-ui/core/Typography';
import Checkbox from '@material-ui/core/Checkbox';
import Card from '@material-ui/core/Card';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import { Doughnut } from 'react-chartjs-2';
import { useTheme } from '@material-ui/styles';
import ExpansionPanelActions from '@material-ui/core/ExpansionPanelActions';
import DeleteIcon from '@material-ui/icons/Delete';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import { Values } from '../../../../../values/Values';
import { putVisitaFiliadoDisp } from '../../../../../services/VisitaFiliadoDispService';
import { putVisitaFiliado } from '../../../../../services/VisitaFiliadoService';


function ExpansionPanelRodada(props) {
  const baseUrl = ServiceValues.base_url_local;
  const timeout = ServiceValues.timeout;
  const api = ServiceAxios(baseUrl, timeout);
  const {
    expandedRodadas,
    setExpandedRodadas,
    visitaFiliado,
    setVisitaFiliado,
    indexModalidade,
    indexVisitaFiliadoTrap,
    setShowMessageSnack,
    setMessageSnack,
    setTypeSnack,
    setLoading,
  } = props;
  const theme = useTheme();

  const classes = useStyles();
  const [numeroRodada, setNumeroRodada] = useState(props.visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoTrap[indexVisitaFiliadoTrap].numeroRodada);
  const [refreshState, setRefreshState] = useState(new Date());
  const [percentualAcertos, setPercentualAcertos] = useState(0);
  const [percentualErros, setPercentualErros] = useState(100);
  const array1 = [0, 1, 2, 3, 4];
  const array2 = [5, 6, 7, 8, 9];
  const array3 = [10, 11, 12, 13, 14];
  const array4 = [15, 16, 17, 18, 19];
  const array5= [20, 21, 22, 23, 24];
  const [data, setData] = useState({
    datasets: [
      {
        data: [
                props.visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoTrap[indexVisitaFiliadoTrap].quantidadeAcertos,
                Values.quantidadeTirosRodadaTrap - props.visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoTrap[indexVisitaFiliadoTrap].quantidadeAcertos
              ],
        backgroundColor: [
          theme.palette.primary.main,
          theme.palette.error.main,
          theme.palette.warning.main
        ],
        borderWidth: 8,
        borderColor: theme.palette.white,
        hoverBorderColor: theme.palette.white
      }
    ],
    labels: ['Acertos', 'Erros']
  });

  useEffect(() => {
    function prepararDados() {
      const percentualErros = ((Values.quantidadeTirosRodadaTrap - props.visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoTrap[indexVisitaFiliadoTrap].quantidadeAcertos) * 100) / Values.quantidadeTirosRodadaTrap;
      const percentualAcertos = (props.visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoTrap[indexVisitaFiliadoTrap].quantidadeAcertos * 100) / Values.quantidadeTirosRodadaTrap;
      setPercentualErros(percentualErros);
      setPercentualAcertos(percentualAcertos);
      setRefreshState(new Date());
    }
    prepararDados();
  }, []);

  function getPercentual(acertos) {
    return acertos * 100 / Values.quantidadeTirosRodadaTrap;
  }

  function registrarAcerto(index, value) {
    if(value){
      visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoTrap[indexVisitaFiliadoTrap].quantidadeAcertos += 1;
    }
    else{
      visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoTrap[indexVisitaFiliadoTrap].quantidadeAcertos -= 1;
    }
    visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoTrap[indexVisitaFiliadoTrap][`${index}`] = value;
    setVisitaFiliado(visitaFiliado);
    setRefreshState(new Date());
    const quantidadeAcertos = visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoTrap[indexVisitaFiliadoTrap].quantidadeAcertos;
    const quantidadeErros = Values.quantidadeTirosRodadaTrap - visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoTrap[indexVisitaFiliadoTrap].quantidadeAcertos;
    const percentualAcerto = getPercentual(quantidadeAcertos);
    const percentualErros = getPercentual(quantidadeErros);
    setPercentualAcertos(percentualAcerto);
    setPercentualErros(percentualErros);
    const dataCopy = {
      datasets: [
        {
          data: [
                  quantidadeAcertos,
                  quantidadeErros
                ],
          backgroundColor: [
            theme.palette.primary.main,
            theme.palette.error.main,
            theme.palette.warning.main
          ],
          borderWidth: 8,
          borderColor: theme.palette.white,
          hoverBorderColor: theme.palette.white
        }
      ],
      labels: ['Acertos', 'Erros']
    };
    setData(dataCopy);
    setRefreshState(new Date());
  }


  const expandRodada = panel => (event, isExpanded) => {
    setExpandedRodadas(isExpanded ? panel : false);
  };

  async function enviarRegistroRodada(event, update) {
    try {
      setLoading(true);
      let result = {};
      if(!visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoTrap[indexVisitaFiliadoTrap].idVisitaFiliadoTrap){
        result = await api.post('/visita-filiado-trap', visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoTrap[indexVisitaFiliadoTrap]);
      }
      else{
        result = await api.put('/visita-filiado-trap', visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoTrap[indexVisitaFiliadoTrap]);
      }
      if (result.data) {
        if (result.data.isSuccess) {
          setLoading(true);
          let resultPutVisitaFiliadoDisp = await putVisitaFiliadoDisp(visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoDisps[0]);
          if(resultPutVisitaFiliadoDisp.isSuccess){
            setLoading(true);
            const dados = await api.get(`visita-filiados/${visitaFiliado.idVisitaFiliado}`);
            setLoading(false);
            if (dados.data.isSuccess) {
              if (dados.data.result && dados.data.result.length > 0) {
                setVisitaFiliado(dados.data.result[0]);
                setLoading(false);
                setTypeSnack('success');
                setMessageSnack('Rodada de Trap Americano registrada com sucesso.');
                setShowMessageSnack(true);
              } else {
                setLoading(false);
                setTypeSnack('error');
                setMessageSnack(Values.MessageValues.erro_catch);
                setShowMessageSnack(true);
              }
            } else {
              setLoading(false);
              setTypeSnack('error');
              setMessageSnack(Values.MessageValues.erro_catch);
              setShowMessageSnack(true);
            }
          }
          else{
            setLoading(false);
            setTypeSnack('error');
            setMessageSnack(resultPutVisitaFiliadoDisp.message);
            setShowMessageSnack(true);
          }

        } else {
          setTypeSnack('error');
          setMessageSnack(result.data.message);
          setShowMessageSnack(true);
          setLoading(false);
        }
      } else {
        setTypeSnack('error');
        setMessageSnack(Values.MessageValues.erro_catch);
        setShowMessageSnack(true);
        setLoading(false);
      }

    } catch (e) {
      setTypeSnack('error');
      setMessageSnack(Values.MessageValues.erro_catch + ' ERROR: ' + e.toString());
      setShowMessageSnack(true);
      setLoading(false);
    }
  }

  async function deleteRodada(event) {
    try {
      setLoading(true);
      let result = {};
      await putVisitaFiliado(visitaFiliado);
      result = await api.delete(`/visita-filiado-trap/${visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoTrap[indexVisitaFiliadoTrap].idVisitaFiliadoTrap}`);
      if (result.data) {
        if (result.data.isSuccess) {
          setLoading(true);
          const dados = await api.get(`visita-filiados/${visitaFiliado.idVisitaFiliado}`);
          setLoading(false);
          if (dados.data.isSuccess) {
            if (dados.data.result && dados.data.result.length > 0) {
              setVisitaFiliado(dados.data.result[0]);
              setLoading(false);
              setTypeSnack('success');
              setMessageSnack('Rodada de Trap Americano registrada com sucesso.');
              setShowMessageSnack(true);
            } else {
              setLoading(false);
              setTypeSnack('error');
              setMessageSnack(Values.MessageValues.erro_catch);
              setShowMessageSnack(true);
            }
          } else {
            setLoading(false);
            setTypeSnack('error');
            setMessageSnack(Values.MessageValues.erro_catch);
            setShowMessageSnack(true);
          }

        } else {
          setTypeSnack('error');
          setMessageSnack(result.data.message);
          setShowMessageSnack(true);
          setLoading(false);
        }
      } else {
        setTypeSnack('error');
        setMessageSnack(Values.MessageValues.erro_catch);
        setShowMessageSnack(true);
        setLoading(false);
      }

    } catch (e) {
      setTypeSnack('error');
      setMessageSnack(Values.MessageValues.erro_catch);
      setShowMessageSnack(true);
      setLoading(false);
    }
  }

    return (
    <Grid
      container
    >
      <Grid
        item
        md={12}
        xs={12}
      >
        <ExpansionPanel
          variant={'outlined'}
          expanded={expandedRodadas === ('panel' + numeroRodada)} onChange={expandRodada('panel' + numeroRodada)}
          style={{
            marginTop: 10
          }}
        >
          <ExpansionPanelSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1bh-content"
            id="panel1bh-header"
          >
            <Typography className={classes.heading}>{"Rodada " + numeroRodada}</Typography>
            <Typography className={classes.secondaryHeading}>{'Informações de disparo e rendimento da rodada ' + numeroRodada}</Typography>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
            <Grid
              container
              spacing={2}
            >
              <Grid
                item
                md={8}
                xs={12}
              >
                <Card
                  className={classes.cardRodadaAndGrafico}
                  variant={'outlined'}
                >
                  <CardHeader
                    title={'Informações da rodada ' + numeroRodada}
                  />
                  <CardContent>
                    <Grid
                      container
                    >
                      <Grid
                        container
                      >
                        <Grid
                        item
                        md={2}
                        xs={12}
                      >
                        <Typography
                          style={{ color: theme.palette.text.primary }}
                          variant="h5"
                        >
                          {'Posto 1'}
                        </Typography>
                      </Grid>

                    {array1.map((value, index1) => {
                      const indexLabel = "acertoDisparo" + (value < 9 ? '0' : '') + (value + 1);
                      return <Grid
                        item
                        md={1}
                        xs={1}
                      >
                        <Grid item md={1} xs={1}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoTrap[indexVisitaFiliadoTrap][`${indexLabel}`]}
                                className={classes.checkbox}
                                label={'0'}
                                color={'primary'}
                                onChange={e => registrarAcerto(indexLabel, !visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoTrap[indexVisitaFiliadoTrap][`${indexLabel}`])}
                                inputProps={{ 'aria-label': 'primary checkbox' }}
                              />
                            }
                            labelPlacement={"start"}
                            label={index1 < 9 ? "0" + (index1 + 1) : index1 + 1}
                          />
                        </Grid>
                      </Grid>

                      })}
                      </Grid>
                      <Grid
                        container
                      >
                        <Grid
                          item
                          md={2}
                          xs={12}
                        >
                          <Typography
                            style={{ color: theme.palette.text.primary }}
                            variant="h5"
                          >
                            {'Posto 2'}
                          </Typography>
                        </Grid>
                    {array2.map((value, index1) => {
                      const indexLabel = "acertoDisparo" + (value < 9 ? '0' : '') + (value + 1)
                      return <Grid
                        item
                        md={1}
                        xs={1}
                      >
                        <Grid item md={1} xs={1}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoTrap[indexVisitaFiliadoTrap][`${indexLabel}`]}
                                className={classes.checkbox}
                                label={'0'}
                                color={'primary'}
                                onChange={e => registrarAcerto(indexLabel, !visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoTrap[indexVisitaFiliadoTrap][`${indexLabel}`])}
                                inputProps={{ 'aria-label': 'primary checkbox' }}
                              />
                            }
                            labelPlacement={"start"}
                            label={index1 < 9 ? "0" + (index1 + 1) : index1 + 1}
                          />
                        </Grid>
                      </Grid>
                      })}
                      </Grid>
                      <Grid
                        container
                      >
                        <Grid
                          item
                          md={2}
                          xs={12}
                        >
                          <Typography
                            style={{ color: theme.palette.text.primary }}
                            variant="h5"
                          >
                            {'Posto 3'}
                          </Typography>
                        </Grid>
                    {array3.map((value, index1) => {
                      const indexLabel = "acertoDisparo" + (value < 9 ? '0' : '') + (value + 1)
                      return <Grid
                        item
                        md={1}
                        xs={1}
                      >
                        <Grid item md={1} xs={1}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoTrap[indexVisitaFiliadoTrap][`${indexLabel}`]}
                                className={classes.checkbox}
                                label={'0'}
                                color={'primary'}
                                onChange={e => registrarAcerto(indexLabel, !visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoTrap[indexVisitaFiliadoTrap][`${indexLabel}`])}
                                inputProps={{ 'aria-label': 'primary checkbox' }}
                              />
                            }
                            labelPlacement={"start"}
                            label={index1 < 9 ? "0" + (index1 + 1) : index1 + 1}
                          />
                        </Grid>
                      </Grid>
                      })}
                      </Grid>
                      <Grid
                        container
                      >
                        <Grid
                          item
                          md={2}
                          xs={12}
                        >
                          <Typography
                            style={{ color: theme.palette.text.primary }}
                            variant="h5"
                          >
                            {'Posto 4'}
                          </Typography>
                        </Grid>
                    {array4.map((value, index1) => {
                      const indexLabel = "acertoDisparo" + (value < 9 ? '0' : '') + (value + 1)
                      return <Grid
                        item
                        md={1}
                        xs={1}
                      >
                        <Grid item md={1} xs={1}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoTrap[indexVisitaFiliadoTrap][`${indexLabel}`]}
                                className={classes.checkbox}
                                label={'0'}
                                color={'primary'}
                                onChange={e => registrarAcerto(indexLabel, !visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoTrap[indexVisitaFiliadoTrap][`${indexLabel}`])}
                                inputProps={{ 'aria-label': 'primary checkbox' }}
                              />
                            }
                            labelPlacement={"start"}
                            label={index1 < 9 ? "0" + (index1 + 1) : index1 + 1}
                          />
                        </Grid>
                      </Grid>
                      })}
                      </Grid>
                      <Grid
                        container
                      >
                        <Grid
                          item
                          md={2}
                          xs={12}
                        >
                          <Typography
                            style={{ color: theme.palette.text.primary }}
                            variant="h5"
                          >
                            {'Posto 5'}
                          </Typography>
                        </Grid>
                    {array5.map((value, index1) => {
                      const indexLabel = "acertoDisparo" + (value < 9 ? '0' : '') + (value + 1)
                      return <Grid
                        item
                        md={1}
                        xs={1}
                      >
                        <Grid item md={1} xs={1}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoTrap[indexVisitaFiliadoTrap][`${indexLabel}`]}
                                className={classes.checkbox}
                                label={'0'}
                                color={'primary'}
                                onChange={e => registrarAcerto(indexLabel, !visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoTrap[indexVisitaFiliadoTrap][`${indexLabel}`])}
                                inputProps={{ 'aria-label': 'primary checkbox' }}
                              />
                            }
                            labelPlacement={"start"}
                            label={index1 < 9 ? "0" + (index1 + 1) : index1 + 1}
                          />
                        </Grid>
                      </Grid>
                      })}
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>
              <Grid
                item
                md={4}
                xs={12}
              >
                <Card
                  className={classes.cardRodadaAndGrafico}
                  variant={'outlined'}
                >
                  <CardHeader
                    title={'Rendimento'}
                  />
                  <CardContent>
                    <Doughnut
                      data={data}
                    />
                    <Grid
                      container
                      style={{
                        marginTop: 20
                      }}
                    >
                      <Grid
                        item
                        lg={9}
                        sm={9}
                        xl={9}
                        xs={9}
                        className={classes.descricaoFinalizadora}
                      >
                        <Typography
                          style={{ color: theme.palette.text.primary }}
                          variant="h5"
                        >
                          {'Percentual Acertos:'}
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        lg={3}
                        sm={3}
                        xl={3}
                        xs={3}
                        key={percentualAcertos}
                      >
                        <Typography
                          style={{
                            color: theme.palette.text.primary,
                            textAlign: 'right'
                          }}
                          variant="h5"
                        >
                          {percentualAcertos.toFixed(2)}%
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        lg={9}
                        sm={9}
                        xl={9}
                        xs={9}
                        style={{
                          marginTop: 10
                        }}
                      >
                        <Typography
                          style={{ color: theme.palette.text.primary }}
                          variant="h5"
                        >
                          {'Percentual Erros:'}
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        lg={3}
                        sm={3}
                        xl={3}
                        xs={3}
                        key={percentualErros}
                        style={{
                          marginTop: 10
                        }}
                      >
                        <Typography
                          style={{
                            color: theme.palette.text.primary,
                            textAlign: 'right'
                          }}
                          variant="h5"
                        >
                          {percentualErros.toFixed(2)}%
                        </Typography>
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          </ExpansionPanelDetails>
          <Divider />
          <ExpansionPanelActions>
            <Button
              variant="text"
              color={'primary'}
              onClick={e => deleteRodada(e)}
              style={{
                color: '#DC004E'
              }}
              startIcon={<DeleteIcon />}
            >
              APAGAR RODADA
            </Button>
            <Button
              variant="text"
              color={'primary'}
              onClick={e => enviarRegistroRodada(e, true)}
              startIcon={<CheckCircleOutlineIcon />}
            >
              ATUALIZAR RODADA
            </Button>
          </ExpansionPanelActions>
        </ExpansionPanel>
      </Grid>
    </Grid>
  );
}

ExpansionPanelRodada.propTypes = {
  className: PropTypes.string,
  visitaFiliado: PropTypes.object.isRequired,
  setVisitaFiliado: PropTypes.object.isRequired
};

export default ExpansionPanelRodada;


